import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Login } from "../helpers/api";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import Input from "../components/input";
import Button from "../components/Button";
import BackgroudLogin from "../assets/icons/backgroundLogin.webp";
import ArrowRight from "../assets/icons/arrow-right.svg";
import LogoHUB from '../assets/icons/logoEasyHUB.svg'

const LoginForm = () => {
  const { setUser } = useContext(UserContext);
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Votre adresse e-mail doit être valide (exemple@domain.com)")
        .required("Veuillez renseigner votre adresse e-mail"),
      password: Yup.string().required("Veuillez renseigner votre mot de passe"),
    }),
    onSubmit: (values) => {
      Login({ email: values.email, password: values.password })
        .then((response) => {
          if (response?.success) {
            setUser(response);
            localStorage.setItem("varBackofficeeasy", JSON.stringify(response));

            const role = response?.user?.role;

            switch (role) {
              case "admin":
                navigate("/admin-home");
                break;
              case "super_admin":
                navigate("/super-admin-home");
                break;
              case "super_agent":
                navigate("/super-agent-home");
                break;
              case "marketing":
                navigate("/marketing-home");
                break;
              default:
                navigate("/agent-home");
                break;
            }
          }
        })
        .catch((err) => {
          setErrorMessage(true);
          formik.resetForm();
        });
    },
  });
  useEffect(() => {
    if (formik.dirty) setErrorMessage(false);
  }, [formik.dirty]);

  return (
    <div
      className="min-h-screen w-full flex items-center  justify-end bg-contain bg-no-repeat "
      style={{
        backgroundImage: `url(${BackgroudLogin})`,
        backgroundSize: "100% 100%",
      }}
    >
      <form
        className="bg-white shadow-[0px_10px_45px_rgba(57,54,196,0.3)] w-full  px-6 md:px-12  mr-[100px] max-w-[500px] flex flex-col gap-6 rounded-2xl py-12 transition-allhandleError"
        onSubmit={formik.handleSubmit}
      >
        <img className="w-[140px] h-auto mx-auto" src={LogoHUB} alt="Logo-HUB-Easy"/>
        
        <div className="text-[#6B7280] text-[16px] text-left mt-12">Veuillez saisir vos identifiants</div>
        <Input
          label="Adresse E-mail"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          id="email"
          name="email"
          autoComplete="email"
          error={formik.touched.email ? formik.errors.email : ""}
          placeholder="Votre adresse e-mail"
        />

        <Input
          label="Mot de passe"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          placeholder="Mot de passe"
          error={formik.touched.password ? formik.errors.password : ""}
        />
        <div className="h-[20px] mb-2 text-[12px] text-[#EE443F]">
          {errorMessage
            ? "Veuillez vérifier l'exactitude de votre adresse e-mail ou de votre mot de passe."
            : " "}
        </div>

        <Button
          variant={
            !formik.isValid || !formik.dirty || errorMessage
              ? "disabled"
              : "primary"
          }
          type="submit"
        >
          <div className="flex gap-2  justify-center items-center">
            Se connecter{" "}
            <img src={ArrowRight} className="mt-1" alt="se-connecter" />
          </div>
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
